// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zSOM","title":"styles_title__3DNgr"};